import React,{useContext, useEffect, useState} from 'react';

import {  
  Card,  
  Button,
  Row,
  Col,
  Modal,
  Form,
  Alert
} from 'react-bootstrap';

import AskTitle from './AskTitle';

const Step1 = (props) => {

  const [mode,setMode] = useState(0);

  const modeAry = [
    "",
    "Convert your PDF/PPT to SCORM",
    "Create your Video SCORM",
    "Build your own Customized SCORM"
  ];

  const startNow = (num) => (e) => {
    setMode(num);   
  }

  const modeCard = (m) => {
    return <Card className="card-box h-100">
      <Card.Body className="p-5">        
        <h3 className="my-2">{modeAry[m]}</h3>
        
        {m===1 &&<>
          <p className="transalte" tid="fileDesc">
            Upload your PDF/PPT to generate slides, use them as they are OR customize them later to build a SCORM package.
        </p>
        </> }

        {m===2 && <>
          <p className="transalte" tid="videoDesc">
            Create interactive learning from your existing videos.
          </p>
        </>}

        {m===3 && <>          
          <p className="transalte" tid="templateDesc">          
            Build your SCORM using our sample slide tools, tune and publish them.
          </p>
        </>}

      </Card.Body>  
      <Card.Footer className="text-center"><Button className="active px-5 py-2 translate" tid="startBtn" onClick={startNow(m)}>Start Now</Button></Card.Footer>
    </Card>
  }
  
  return <>
    
    <div className="heading mb-4 translate" tid="header">Let's get started! Build your course.</div>
     
    <div className="home3step">
    <Row>
      <Col className="mt-3">{modeCard(1)}</Col>
      <Col className="mt-3">{modeCard(2)}</Col>
      <Col className="mt-3">{modeCard(3)}</Col>
    </Row>
    </div>
    {mode >= 1 && <AskTitle onHide={() => setMode(0)} onSuccess={(sprops) => {props.onContinue(mode, sprops)}} />}
  </>;
}

export default Step1;